import React from "react";
import {Box} from "@mui/system";
import { Typography, useMediaQuery} from "@mui/material";

import {theme} from "../../../../../utils";
import {resourceCardStyles} from "./resourceCard-helpers";
import FilePdfIcon from "../../../../../assets/images/svgs/file-pdf.svg";
import {DownloadButton, DownloadButtonType} from "../../../../../components";

export const ResourceCard = (props: any) => {
    const {image, title, filePath, enableDownload = true} = props;
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <Box sx={resourceCardStyles.cardBody} >
            <img src={image}  style={resourceCardStyles.image}  alt={title} />

            <Box sx={resourceCardStyles.download.container}>
                {enableDownload ?
                    <Box pl={isMobileX ? "0px" : "36px"} mt="24px" sx={isMobileX ? { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" } : null}>
                        <Typography sx={resourceCardStyles.download.ctaTitle} variant="h4" component="div">
                            {title}
                        </Typography>
                        <Box sx={{  }}>
                            <DownloadButton fileUrl={filePath} buttonIcon={FilePdfIcon} buttonText="Open PDF" buttonType={DownloadButtonType.Pdf} />
                        </Box>
                    </Box> : null
                }
            </Box>
        </Box>
    )
}